import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFontStyle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFontStyle"><Path fillRule="evenodd" clipRule="evenodd" d="M19.1826 19.75H20.5V21H14.5V19.75H16.0264L14.3174 14.5H8.05566L6.34668 19.75H7.75V21H3.5V19.75H4.76953L10.2227 3H13.7295L19.1826 19.75ZM8.54395 13H13.8291L11.1865 4.88379L8.54395 13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFontStyle;
